module.exports = __webpack_public_path__ + "img/filter.1adf99cd.svg";